import { DateTime } from 'luxon';

export const upcomingSale = sale => (
  sale && !['Processing', 'Closed'].includes(sale.status) &&
    (!sale.endAt || Date.parse(sale.endAt) > new Date().getTime())
);

export const preBidSale = sale => (
  sale && DateTime.fromISO(sale.startAt) > DateTime.now()
);

// Clerks open the room well ahead of startAt, so their switch decides this,
// not the clock.
export const enterableSale = sale => !!(upcomingSale(sale) && sale.bidding);
